import { SensorExtractionStateType } from './state'

export interface SensorExtractionGettersType {
  getSensorExtractionById: (state: SensorExtractionStateType, id: string) => SensorExtractionStateType['sensorExtraction']
  getSensorExtractionsBySensorSettingId: (state: SensorExtractionStateType, sensorSettingId: string) => SensorExtractionStateType['sensorExtractions']
  getSensorExtractionsByType: (state: SensorExtractionStateType, type: string) => SensorExtractionStateType['sensorExtractions']
  getActiveSensorExtractions: (state: SensorExtractionStateType) => SensorExtractionStateType['sensorExtractions']
  getOverdueSensorExtractions: (state: SensorExtractionStateType) => SensorExtractionStateType['sensorExtractions']
  getSensorExtractionsByPollingInterval: (state: SensorExtractionStateType, interval: number) => SensorExtractionStateType['sensorExtractions']
  getRecentlySyncedExtractions: (state: SensorExtractionStateType, minutes: number) => SensorExtractionStateType['sensorExtractions']
}

export const SensorExtractionGetters = {
  getSensorExtractionById: (state: SensorExtractionStateType) => (id: string) => {
    return state.sensorExtractions.find(sensorExtraction => sensorExtraction.id === id)
  },
  getSensorExtractionsBySensorSettingId: (state: SensorExtractionStateType) => (sensorSettingId: string) => {
    return state.sensorExtractions.filter(sensorExtraction => sensorExtraction.sensorSettingId === sensorSettingId)
  },
  getSensorExtractionsByType: (state: SensorExtractionStateType) => (type: string) => {
    return state.sensorExtractions.filter(sensorExtraction => sensorExtraction.type === type)
  },
  getActiveSensorExtractions: (state: SensorExtractionStateType) => {
    return state.sensorExtractions.filter(sensorExtraction => sensorExtraction.active)
  },
  getOverdueSensorExtractions: (state: SensorExtractionStateType) => {
    return state.sensorExtractions.filter(sensorExtraction => sensorExtraction.isOverdue())
  },
  getSensorExtractionsByPollingInterval: (state: SensorExtractionStateType) => (interval: number) => {
    return state.sensorExtractions.filter(sensorExtraction => sensorExtraction.pollingInterval === interval)
  },
  getRecentlySyncedExtractions: (state: SensorExtractionStateType) => (minutes = 30) => {
    const cutoffTime = new Date()
    cutoffTime.setMinutes(cutoffTime.getMinutes() - minutes)
    
    return state.sensorExtractions.filter(sensorExtraction => {
      return new Date(sensorExtraction.lastSyncAt) >= cutoffTime
    })
  },
}
